import { FunctionComponent } from "react";
import styles from "./ChangePasswordTitle.module.css";
import images from "../../../assets/images/index";

interface ChangePasswordProps {
  handlecloseDialog: any;
}
const ChangePasswordTitle: FunctionComponent<ChangePasswordProps> = ({
  handlecloseDialog,
}) => {
  const {  CloseIcon } = images;
  return (
    <div className={styles.title}>
      <div className={styles.changePassword}>
        <div className={styles.changePassword1}>Change Password</div>
        <div className={styles.enterYourEmail}>{`Enter your new password`}</div>
      </div>

      <div className={styles.closeicon}>
        <img src={CloseIcon} alt="closeicon" data-testid='closeicon' onClick={handlecloseDialog} />
      </div>
    </div>
  );
};

export default ChangePasswordTitle;
